import React, { useContext, useState } from 'react';
import { createUseStyles } from 'react-jss';

import { Button } from '@wds/button';
import { T } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import { Sheet } from '@wds/sheet';
import { Theme } from '@wds/styles';

import HeaderContext from '../../../HeaderContext';
import { ExperimentVariant, View } from './types';
import {
  DrillDownMenuVariant,
  SingleLevelVariant,
} from './ButtonCreateVariants';

export const COPY = {
  createSurvey: {
    id: 'ButtonCreateVariant.createSurvey',
    defaultMessage: 'Create survey',
    description:
      '[Type: Button][Vis.: high] - This is the create survey addon button on the header.',
  },
};

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    color: theme.palette.text.dark,
  },
}));

const ButtonCreate = ({ treatment }: { treatment: ExperimentVariant }) => {
  const { pageURL, pageName } = useContext(HeaderContext);
  const [view, setView] = useState(View.None);

  const { container } = useStyles();

  return (
    <div className={container}>
      <Button
        size="sm"
        color="alt"
        onClick={() => setView(View.StartingPoint)}
        data-sm-metrics={generateMetricsAttribute({
          data: {
            url: pageURL,
            pageName,
            amplitudeEvent: 'header clicked cta',
            ctaName: 'create survey',
          },
        })}
      >
        <T desc={COPY.createSurvey} />
      </Button>
      <Sheet
        show={view !== View.None}
        onClose={() => setView(View.None)}
        size="md"
      >
        <Choose>
          <When condition={treatment === ExperimentVariant.DrillDownMenu}>
            <DrillDownMenuVariant
              view={view}
              setView={setView}
              pageName={pageName ?? ''}
            />
          </When>
          <Otherwise>
            <SingleLevelVariant view={view} pageName={pageName ?? ''} />
          </Otherwise>
        </Choose>
      </Sheet>
    </div>
  );
};

export default ButtonCreate;
